import BasePageView from "components/core/BasePageView/BasePageView";
import useSellerContext from "hooks/useSellerContext";
import usePayoutPageLogic from "./usePayoutPageLogic";
import PayoutDesktop from "./PayoutDesktop";
import PayoutMobile from "./PayoutMobile";

const PayoutView = () => {
  const vm = usePayoutPageLogic();
  const { currentSellerDetail, allSellersDetails, handleProfileNavigate } = useSellerContext();

  return (
    <BasePageView
      DesktopView={PayoutDesktop}
      MobileView={PayoutMobile}
      viewProps={vm}
      headerProps={{
        showSubHeader: true,
        sellerDetail: currentSellerDetail,
        allSellerDetails: allSellersDetails,
        handleProfile: handleProfileNavigate,
      }}
    />
  );
};

export default PayoutView;
